var r = /* @__PURE__ */ ((e) => (e.Direct = "direct", e.Store = "store", e.Mobile = "mobile", e))(r || {}), i = /* @__PURE__ */ ((e) => (e.ComingSoon = "ComingSoon", e.PreRegister = "PreRegister", e.Ready = "Ready", e))(i || {});
export {
  i as DownloadStatus,
  r as DownloadType
};
//# sourceMappingURL=download.js.map
